import styled from 'styled-components'

export const RecordedEl = styled.div`
  display: block;
  width: 100%;
  height: calc(100vh - 5em);

  @media (max-device-width: 1366px) {
    font-size: 0.9em;
  }
`

export const LeftEl = styled.div`
  display: block;
  width: 100%;
  height: 100%;
  overflow: auto;
  padding-right: 29em;

  .ps__rail-y {
    display: none;
  }
`
